import { render, staticRenderFns } from "./ExpandableIdCell.vue?vue&type=template&id=83dd7a48&"
import script from "./ExpandableIdCell.vue?vue&type=script&lang=babel&"
export * from "./ExpandableIdCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports